import { render, staticRenderFns } from "./RecursiveMessages.vue?vue&type=template&id=0d06bbaa&scoped=true&lang=pug&"
import script from "./RecursiveMessages.vue?vue&type=script&lang=js&"
export * from "./RecursiveMessages.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveMessages.vue?vue&type=style&index=0&id=0d06bbaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06bbaa",
  null
  
)

export default component.exports